import { useMutation } from '@apollo/client';
import { useState } from 'react';
import {
    BudgetFieldsFragment,
    UpdateBudgetDocument,
} from '../../graphql/generated';
import { sum } from '../../util/arrays';
import { GoalWithMonthlyAmount } from './useGoalData';

export const useSavingInvestingFormProps = ({
    onComplete,
    onError,
    budget,
    goals,
}: {
    onComplete: VoidFunction;
    onError: (err: unknown) => void;
    budget: BudgetFieldsFragment;
    goals: GoalWithMonthlyAmount[];
}) => {
    const totalAmount = sum(goals, (g) => g.monthlyAmount);
    const [amount, setAmount] = useState(
        budget.savingInvestingAmount || totalAmount
    );
    const [updateBudget, { loading: isSubmitting }] =
        useMutation(UpdateBudgetDocument);

    const handleSubmit = async () => {
        try {
            await updateBudget({
                variables: {
                    input: {
                        id: budget.id,
                        patch: {
                            savingInvestingAmount: amount,
                        },
                    },
                },
            });

            onComplete();
        } catch (e) {
            onError(e);
        }
    };

    return {
        amount,
        setAmount,
        isSubmitting,
        handleSubmit,
    };
};
